import { render, staticRenderFns } from "./ListCustomerLocation.vue?vue&type=template&id=b553c7f6"
import script from "./ListCustomerLocation.vue?vue&type=script&lang=js"
export * from "./ListCustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListCustomerLocation.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b553c7f6')) {
      api.createRecord('b553c7f6', component.options)
    } else {
      api.reload('b553c7f6', component.options)
    }
    module.hot.accept("./ListCustomerLocation.vue?vue&type=template&id=b553c7f6", function () {
      api.rerender('b553c7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListCustomerLocation.vue"
export default component.exports